import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { MARKETPLACE_PAGES } from "@/data/marketplace-pages";

export const PLATFORM_GROUPS = {
  marketplaces: ["amazon-seller-account-management", "flipkart-seller-account-management", "meesho-seller-account-management", "jiomart-seller-onboarding"],
  premium: ["myntra-seller-onboarding", "ajio-seller-onboarding", "nykaa-seller-onboarding", "tatacliq-seller-onboarding"],
  quick: ["blinkit-seller-onboarding", "zepto-seller-onboarding", "instamart-seller-onboarding"],
};

const EXTRA = [
  { to: "/services/a-plus-listing-graphics/", label: "A+ Content & Listing Graphics" },
  { to: "/services/ecommerce-video-creation/", label: "E-commerce Product Videos" },
  { to: "/web-app-development/", label: "E-commerce Website & App Development" },
  { to: "/sales-events/", label: "Sale Event Preparation" },
  { to: "/ecommerce-services-usa/", label: "Amazon.com & Walmart (USA)" },
  { to: "/ecommerce-services-uae/", label: "Amazon.ae & Noon (Dubai, UAE)" },
];

/** Crawlable links to every platform service page, grouped by channel. */
export default function PlatformLinks({ groups = ["marketplaces", "premium", "quick"], extra = false, title = "Platform-specific services" }) {
  const links = groups.flatMap((g) => PLATFORM_GROUPS[g]).map((slug) => ({ to: `/services/${slug}/`, label: MARKETPLACE_PAGES[slug].hero }));
  if (extra) links.push(...EXTRA);
  return (
    <section className="border-t-2 border-black bg-[#FAFAF7] py-16 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-8">
        <h2 className="display text-3xl font-black tracking-tight md:text-4xl">{title}</h2>
        <ul className="mt-8 grid gap-3 sm:grid-cols-2 lg:grid-cols-3">
          {links.map((l) => (
            <li key={l.to}>
              <Link to={l.to} className="flex min-h-[44px] items-center justify-between gap-3 border-2 border-black bg-white px-4 py-3 text-sm font-bold hover:bg-[#FFD700]">
                {l.label} <ArrowUpRight size={16} className="shrink-0" />
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
